import { LinkTypeEnum } from '@models/link/link-type.enum';

export class Link {
  media: LinkTypeEnum;
  url: string;
  urlBuildingInfo: string;

  constructor(data = {}) {
    this.media = data['media'] || '';
    this.urlBuildingInfo = data['urlBuildingInfo'] || '';
    this.url = this.buildUrl(data['media'], data['urlBuildingInfo']);
  }

  buildIconName(media: LinkTypeEnum): string {
    if (media === LinkTypeEnum.Other) {
      return 'blog';
    }

    return media.toString().toLowerCase();
  }

  checkIfUsingCompleteUrl(media: LinkTypeEnum): boolean {
    switch (media) {
      case LinkTypeEnum.Behance:
      case LinkTypeEnum.Dribbble:
      case LinkTypeEnum.Facebook:
      case LinkTypeEnum.Github:
      case LinkTypeEnum.Instagram:
      case LinkTypeEnum.Pinterest:
      case LinkTypeEnum.Skype:
      case LinkTypeEnum.Twitter:
        return false;
      default:
        return true;
    }
  }

  private buildUrl(media: LinkTypeEnum, urlBuildingInfo: string): string {
    if (!media || !urlBuildingInfo) {
      return '';
    }

    const prefixHttpsEverywhere = /(?:https?:\/\/)?(.*?\..*?)(\/.*?(?:\..*?)?)?$/g;
    /*
     * The regex above is able to select a wide range of url, with or without http prefixes
     * We can use it to enforce all displayed url will be navigable
     * This might be a problem if target url does not support https :
     * - browser will warn about incorrect certificate
     * - server might not allow https connection
     *
     * Alternatively we can use : const forceAtLeastHttpPrefix = /^((?!https?:\/\/).*)$/g;
     * to set at least http prefix, relying on the fact that https websites should
     * - set hsts header
     * - redirect all http connection to https
     */

    switch (media) {
      case LinkTypeEnum.Behance:
        return `https://www.behance.com/${urlBuildingInfo}`;
      case LinkTypeEnum.Dribbble:
        return `https://www.dribbble.com/${urlBuildingInfo}`;
      case LinkTypeEnum.Facebook:
        return `https://www.facebook.com/${urlBuildingInfo}`;
      case LinkTypeEnum.Github:
        return `https://www.github.com/${urlBuildingInfo}`;
      case LinkTypeEnum.Instagram:
        return `https://www.instagram.com/${urlBuildingInfo}`;
      case LinkTypeEnum.Pinterest:
        return `https://www.pinterest.com/${urlBuildingInfo}`;
      case LinkTypeEnum.Skype:
        return `skype:${urlBuildingInfo}?call`;
      case LinkTypeEnum.Twitter:
        return `https://www.twitter.com/${urlBuildingInfo}`;
      default:
        return urlBuildingInfo.replace(prefixHttpsEverywhere, 'https://$1$2');
    }
  }
}
